import {Injectable} from '@angular/core';
import {DialogService} from '../dialog.service';
import {SureModalComponent} from 'src/app/shared/ui-kits/table/sure-modal/sure-modal.component';
import {filter, Observable} from 'rxjs';
import {ISureConfig} from 'src/app/interfaces/sure-modal.interface';

@Injectable({
  providedIn: 'root',
})
export class SureModalService {
  constructor(private dialogService: DialogService) {}

  openModal(body: ISureConfig): Observable<boolean> {
    return this.dialogService
      .open(SureModalComponent, {
        settings: {
          width: '180px',
          height: '150px',
        },
        data: {
          ...body,
        },
      })
      .afterClosed();
  }

  confirmAction(body: ISureConfig): Observable<boolean> {
    return this.openModal(body).pipe(filter(res => !!res));
  }
}
